import { useNavigate } from "react-router-dom";

import { MainContainer } from "@/components/Layout/Styled";
import Meta from "@/components/Meta";
import EmailRecoveryForm from "@/pages/Profile/ChangePhone/ChangePhoneForm";
import {
    AuthWrapper,
    ForgetPasswordWrapper,
    StyledLink,
} from "@/pages/Profile/ChangePhone/Styled";

const ChangePhone = () => {
    const navigate = useNavigate();
    return (
        <>
            <Meta title="Change Phone" />
            <MainContainer>
                <AuthWrapper>
                    <EmailRecoveryForm />
                </AuthWrapper>
                <ForgetPasswordWrapper>
                    <StyledLink onClick={() => navigate("/profile")}>
                        Повернутись до профілю
                    </StyledLink>
                </ForgetPasswordWrapper>
            </MainContainer>
        </>
    );
};

export default ChangePhone;
